import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './language'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 换肤必须放在 Element UI 的样式**之后**：这里全是覆盖规则，顺序错了就不生效
import './theme.css';
Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
